import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
  defineMessages,
} from 'react-intl';
import classes from './unauthorized-view.scss';
import { LinearProgress } from '@getgo/chameleon-web-react-wrapper';
import { Box } from '@mui/material';
import { Typography } from '@getgo/chameleon-web-react-wrapper';
import { LaunchOutlinedIcon } from '@getgo/chameleon-icons/react';
import { colors } from '@getgo/chameleon-core';

export const UnauthorizedView = (props) => {
  const t = defineMessages({
    'common.forbidden': {
      id: 'common.forbidden',
      defaultMessage: 'You seem to have landed in the wrong place.',
    },
    'common.contact-admin': {
      id: 'common.contact-admin',
      defaultMessage: 'Please contact the account admin to gain access to this location. We will now redirect you to your {account}.',
    },
    'common.contact-admin.account-profile': {
      id: 'common.contact-admin.account-profile',
      defaultMessage: 'account profile',
    },
  });

  return (
    <Box id="unauthorized-view" className={`text-center ${classes['unauthorized-view']}`}>
      <Box className={classes["alignedContent"]}>
        <LaunchOutlinedIcon size="88px" color={colors.blue.b400} />
      </Box>
      <Box className={classes["mainHeading"]}>
        <Typography variant="heading-medium">
          <FormattedMessage {...t["common.forbidden"]} />
        </Typography>
      </Box>
      <Box className="row">
        <Typography variant="body-medium">
          <FormattedMessage
            {...t['common.contact-admin']}
            values={{
              account:  <a href={props.accountUrl}><FormattedMessage {...t['common.contact-admin.account-profile']} /></a>
            }}
          />
        </Typography>
      </Box>
      <LinearProgress value={props.percent} size="large" />
    </Box>
  );
};

UnauthorizedView.propTypes = {
  accountUrl: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
};

export default UnauthorizedView;
